<template>
  <el-dialog
    title="修改币种介绍"
    width="1200px"
    :visible.sync="detailDialogVisible"
    @close="closeDialog"
    @open="openDialog"
  >
    <el-form
      label-width="200px"
      :model="introductionDetail"
      :rules="rules"
      ref="currencyIntroductionForm"
    >
      <el-form-item label="币种名称：" prop="coinName">
        <el-input
          :value="introductionDetail.coinName"
          @input="handleChange('coinName', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="币种：" prop="coin">
        <el-input
          :value="introductionDetail.coin"
          @input="handleChange('coin', $event)"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="币种代码：" prop="coinCode">
        <el-input :value="introductionDetail.coinCode" @input="handleChange('coinCode', $event)"></el-input>
      </el-form-item> -->
      <el-form-item label="币种类型：" prop="coinType">
        <el-input
          :value="introductionDetail.coinType"
          @input="handleChange('coinType', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="发行价：" prop="issuePrice">
        <el-input
          :value="introductionDetail.issuePrice"
          @input="handleChange('issuePrice', $event)"
        ></el-input>
      </el-form-item>

      <el-form-item label="总发行量：" prop="totalAmount">
        <el-input
          :value="introductionDetail.totalAmount"
          @input="handleChange('totalAmount', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="流通量：" prop="flowAmount">
        <el-input
          :value="introductionDetail.flowAmount"
          @input="handleChange('flowAmount', $event)"
        ></el-input>
      </el-form-item>

      <el-form-item label="发行日期：" prop="issueDate">
        <el-date-picker
          :value="introductionDetail.issueDate"
          type="date"
          placeholder="选择日期"
          @input="handleChange('issueDate', $event)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="共识机制：" prop="mechanism">
        <el-input
          :value="introductionDetail.mechanism"
          @input="handleChange('mechanism', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="区块浏览器：" prop="blockLink">
        <el-input
          :value="introductionDetail.blockLink"
          @input="handleChange('blockLink', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="项目官网：" prop="projectLink">
        <el-input
          :value="introductionDetail.projectLink"
          @input="handleChange('projectLink', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="Github地址：" prop="githubLink">
        <el-input
          :value="introductionDetail.githubLink"
          @input="handleChange('githubLink', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="白皮书：" prop="whitePaperLink">
        <el-input
          :value="introductionDetail.whitePaperLink"
          @input="handleChange('whitePaperLink', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片：" prop="coinUrl">
        <Upload
          :value="introductionDetail.coinUrl"
          @input="handleChange('coinUrl', $event)"
          :data="{
            isSprite: false,
            category: 'coin',
            tenantId: 1,
          }"
        ></Upload>
      </el-form-item>
      <el-form-item label="简介：" prop="description">
        <div
          v-for="lang in languages"
          :key="lang.value"
          class="introduction-editor"
        >
          <div class="introduction-editor-header">（{{ lang.label }}简介）</div>
          <editor
            :value="introductionDetail.description[lang.value]"
            @change="handleEditorChange('description', lang.value, $event)"
          ></editor>
        </div>
      </el-form-item>
      <el-form-item label="团队介绍：" prop="teamDescription">
        <div
          v-for="lang in languages"
          :key="lang.value"
          class="introduction-editor"
        >
          <div class="introduction-editor-header">
            （{{ lang.label }}团队介绍）
          </div>
          <editor
            :value="introductionDetail.teamDescription[lang.value]"
            @change="handleEditorChange('teamDescription', lang.value, $event)"
          ></editor>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSave('currencyIntroductionForm')"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Editor from "components/editor";
import LANGUAGES from "common/languages";
import Upload from "components/upload";
export default {
  name: "CurrencyIntroductionDetail",
  props: ["id"],
  data() {
    return {
      languages: Object.keys(LANGUAGES).map((lang) => ({
        label: LANGUAGES[lang],
        value: lang,
      })),
      rules: {
        code: [{ required: true, message: "请输入币种名称" }],
      },
    };
  },
  computed: {
    ...mapState("currencyIntroductionSetting", [
      "detailDialogVisible",
      "introductionDetail",
    ]),
  },
  components: {
    Editor,
    Upload
  },
  methods: {
    ...mapActions("currencyIntroductionSetting", ["update", "detail"]),
    ...mapMutations("currencyIntroductionSetting", [
      "toggleDetailDialogVisible",
      "setIntroductionDetail",
    ]),
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.update({
            ...this.introductionDetail,
            description: JSON.stringify(this.introductionDetail.description),
            teamDescription: JSON.stringify(
              this.introductionDetail.teamDescription
            ),
          }).then(() => {
            this.$message.success("修改成功！");
            this.toggleDetailDialogVisible(false);
            this.$emit("refresh");
          });
        }
      });
    },
    handleCancel() {
      this.toggleDetailDialogVisible(false);
    },
    handleChange(key, value) {
      this.setIntroductionDetail({
        ...this.introductionDetail,
        [key]: value,
      });
    },
    handleEditorChange(type, key, value) {
      this.setIntroductionDetail({
        ...this.introductionDetail,
        [type]: {
          ...this.introductionDetail[type],
          [key]: value,
        },
      });
    },
    openDialog() {
      this.detail(this.id);
    },
    closeDialog() {
      this.toggleDetailDialogVisible(false);
      this.setIntroductionDetail({
        description: {},
        teamDescription: {},
      });
      this.$refs["currencyIntroductionForm"].resetFields();
    },
  },
};
</script>

<style lang="less" scoped></style>
